import { useEffect } from "react";
import useItemStore from "../../stores/useItemStore";
import getItemCategories from "../../api/auth/itemCategories/getItemCategories";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import WushSortableTable from "../../components/layout/WushSortableTable";
import { Delete, Edit, Search } from "@mui/icons-material";
import WushPopover from "../../components/layout/WushPopover";
import { useNavigate } from "react-router-dom";
import ItemCategoryForm from "../../components/form/itemCategory/ItemCategoryForm";
import ItemCategoryName from "../../components/text/ItemCategoryName";
import deleteItemCategory from "../../api/auth/itemCategories/deleteItemCategory";

export default function ItemCategories() {
  const { itemCategories, setItemCategories, removeItemCategory } = useItemStore();

  useEffect(() => {
    getItemCategories((response) => {
      setItemCategories(response);
    });
  }, []);

  const navigate = useNavigate();

  const handleDelete = (itemCategory) => {
    deleteItemCategory(itemCategory.id, () => {
      removeItemCategory(itemCategory);
    });
  };

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">
          Item Categories
        </Typography>
        <Typography variant="body1">
          Manage item categories. These groups are used to organize different types of items and can be used to create store pages for different categories.
        </Typography>
      </Stack>
      <Stack mb={2}>
        <WushPopover
          anchor={
            <Button variant="contained" color="primary">
              Add Item Category
            </Button>
          }
        >
          <Stack p={2}>
            <ItemCategoryForm showImage />
          </Stack>
        </WushPopover>
      </Stack>
      <WushSortableTable
        title="Items"
        onRowClick={(row) => navigate(`/item_categories/${row.id}`)}
        headers={[
          {
            id: 1,
            key: "id",
            label: "ID"
          },
          {
            id: 2,
            label: "Name",
            customValue: (row) => <ItemCategoryName itemCategory={row} />
          },
          {
            id: 3,
            key: "description",
            label: "Description"
          },
          {
            id: 4,
            label: "Actions",
            customValue: (row) => console.log(row) || (
              <Stack direction="row">
                <WushPopover
                  anchor={
                    <IconButton>
                      <Edit />
                    </IconButton>
                  }
                >
                  <Stack
                    p={2}
                  >
                    <ItemCategoryForm itemCategory={row} showImage />
                  </Stack>
                </WushPopover>
                <IconButton onClick={() => navigate(`/item_categories/${row.id}`)}>
                  <Search />
                </IconButton>
                {row.deletable && <IconButton onClick={() => handleDelete(row)}>
                  <Delete />
                </IconButton>}
              </Stack>
            )
          }
        ]}
        data={itemCategories}
      />
    </Stack>
  );
}